import React, { useEffect, useState } from 'react';
import Splash from '../components/layout/splash';
import { useNavigate } from 'react-router-dom';
import './onboarding.css';

import logo from '../assets/icons/primaryLogo.svg';
import arabicLogo from '../assets/icons/arabicLogo.svg';
import radwa from '../assets/imgs/radwa.png';
import exhibitorsImg from '../assets/icons/exhibitors.svg';
import ticketImg from '../assets/icons/ticket.png';

const slides = [
  {
    image: radwa,
    title: 'Cairo International Book Fair',
    text: 'Features Radwa Ashour as the year’s personality',
    type: 'radwa',
  },
  {
    image: exhibitorsImg,
    title: 'Explore exhibitors',
    text: 'Search by title, author, language, or publisher',
    type: 'exhibitors',
  },
  {
    image: ticketImg,
    title: 'Plan your visit',
    text: 'Book your ticket, navigate, and save events',
    type: 'ticket',
  },
];

const Onboarding = () => {
  const [loading, setLoading] = useState(true);
  const [step, setStep] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return <Splash />;
  }

  const currentSlide = slides[step];

  const nextSlide = () => {
    if (step < slides.length - 1) {
      setStep(step + 1);
    }
  };

  const goToSignup = () => {
    navigate('/Signup');
  };

  const goToLogin = () => {
    navigate('/Login');
  };

  return (
    <main className="onboardingPage">
      <div className="onboardingTop">
        <img src={logo} alt="Cairo International Book Fair logo" />
        <img src={arabicLogo} alt="Arabic logo" />
      </div>

      <section className={`onboardingVisual ${currentSlide.type}`}>
        <div className="orangeShape"></div>
        <img
          src={currentSlide.image}
          alt={currentSlide.title}
          className="onboardingImage"
        />
      </section>

      <div className="dots">
        {slides.map((_, index) => (
          <span
            key={index}
            className={step === index ? 'activeDot' : ''}
            onClick={() => setStep(index)}
          ></span>
        ))}
      </div>

      <section className="onboardingContent">
        <h1>{currentSlide.title}</h1>
        <p>{currentSlide.text}</p>

        {step < slides.length - 1 ? (
          <button className="primaryBtn" onClick={nextSlide}>
            Next
          </button>
        ) : (
          <div className="onboardingActions">
            <button className="primaryBtn createBtn" onClick={goToSignup}>
              Create Account
            </button>

            <button className="secondaryBtn" onClick={goToLogin}>
              Log in
            </button>
          </div>
        )}
      </section>
    </main>
  );
};

export default Onboarding;